import { IDepartmentActions, DepartmentContext } from './actions.types';
import { IDepartmentData } from '@/models';

export const actions: IDepartmentActions = {
  fetchDepartments(
    context: DepartmentContext,
    payload?: boolean
  ): Promise<void> {
    return this.$services.department
      .fetchDepartments(payload)
      .then((departments: IDepartmentData[]) => {
        context.commit('SET_DEPARTMENTS', departments);
      });
  },

  fetchDepartment(context: DepartmentContext, payload: number): Promise<void> {
    return this.$services.department
      .fetchDepartment(payload)
      .then((department: IDepartmentData) => {
        const index = context.state.departments.findIndex(
          (v: IDepartmentData) => v.id === department.id
        );
        if (index === -1) {
          context.commit('ADD_DEPARTMENT', department);
        } else {
          context.commit('UPDATE_DEPARTMENT', department);
        }
      });
  },

  createDepartment(
    context: DepartmentContext,
    payload: IDepartmentData
  ): Promise<void> {
    return this.$services.department
      .createDepartment(payload)
      .then((department: IDepartmentData) =>
        context.commit('ADD_DEPARTMENT', department)
      );
  },

  updateDepartment(
    context: DepartmentContext,
    payload: IDepartmentData
  ): Promise<void> {
    return this.$services.department
      .updateDepartment(payload)
      .then((department: IDepartmentData) => {
        const index = context.state.departments.findIndex(
          (v: IDepartmentData) => v.id === department.id
        );
        if (index === -1) {
          context.commit('ADD_DEPARTMENT', department);
        } else {
          context.commit('UPDATE_DEPARTMENT', department);
        }
      });
  },

  deleteDepartment(context: DepartmentContext, payload: number): Promise<void> {
    return this.$services.department.deleteDepartment(payload).then(() => {
      context.commit('REMOVE_DEPARTMENT', payload);
    });
  }
};
